import { UPDATE_PAGE_PROGRESS } from './actions';

export const updatePageProgress = (pagePath, changes) => ({
  type: UPDATE_PAGE_PROGRESS,
  pagePath,
  changes,
});
